import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import AccountsListFilters from './AccountsListFilters';
import listQueryFilter from 'components/hoc/listQueryFilter';
import theme from 'theme/theme';
import { deleteAccount } from 'store/actions/accounts/deleteAccounts';
import { fetchAccounts } from 'store/actions/accounts/fetchAccounts';

const AccountsList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <AccountsListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchAccounts }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    colorToggle={ {
                        condition: false,
                        color: theme.palette.gray,
                        key: 'is_enabled',
                    } }
                >
                    <TextField
                        column={ {
                            sortable: true,
                            width: '25%',
                        } }
                        label='resources.accounts.fields.name'
                        maxCharacters={ 100 }
                        source='name'
                    />

                    <TextField
                        column={ {
                            width: '25%',
                        } }
                        label='resources.accounts.fields.email'
                        source='email'
                    />
                    <TextField
                        column={ {
                            width: '10%',
                        } }
                        label='resources.accounts.fields.phone'
                        source='phone'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deleteAccount } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

AccountsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(AccountsList);



// WEBPACK FOOTER //
// ./src/pages/accounts/list/AccountsList.js